/**
 * Category Showcase — Swiper with arrow controls
 * Arrows auto-disable at scroll boundaries.
 * Handles multiple instances on the same page.
 */

(function () {
  'use strict';

  function initShowcase(track) {
    const section  = track.closest('.category-showcase');
    if (!section) return;

    const prevBtn  = section.querySelector('.category-showcase__arrow--prev');
    const nextBtn  = section.querySelector('.category-showcase__arrow--next');
    if (!prevBtn || !nextBtn) return;

    /** Scroll amount = one card width + gap */
    function scrollStep() {
      const card = track.querySelector('.category-showcase__card');
      if (!card) return 220;
      const gap = parseFloat(getComputedStyle(track).gap) || 12;
      return card.offsetWidth + gap;
    }

    /** Update disabled state of both arrows */
    function updateArrows() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const atStart   = track.scrollLeft <= 2;
      const atEnd     = maxScroll <= 0 || track.scrollLeft >= maxScroll - 2;

      prevBtn.classList.toggle('is-disabled', atStart);
      nextBtn.classList.toggle('is-disabled', atEnd);

      prevBtn.setAttribute('aria-disabled', String(atStart));
      nextBtn.setAttribute('aria-disabled', String(atEnd));
    }

    prevBtn.addEventListener('click', function () {
      if (prevBtn.classList.contains('is-disabled')) return;
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      if (nextBtn.classList.contains('is-disabled')) return;
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });

    // Recalculate on resize (e.g. orientation change)
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateArrows, 100);
    }, { passive: true });

    // Initial state
    updateArrows();
  }

  /** Init all instances — also support Theme Editor re-renders */
  function initAll() {
    document.querySelectorAll('.category-showcase__track').forEach(function (track) {
      if (track.dataset.csInit) return; // prevent double-init
      track.dataset.csInit = '1';
      initShowcase(track);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor: re-init when a section is loaded/reordered
  document.addEventListener('shopify:section:load', function (e) {
    const track = e.target.querySelector('.category-showcase__track');
    if (!track) return;
    delete track.dataset.csInit;
    initShowcase(track);
  });

})();
